// useNumberField.js
import { useState, useCallback } from "react";

export function useNumberField(initial) {
  const [raw, setRaw] = useState(
    initial === undefined || initial === null ? "" : String(initial)
  );

  const onChange = useCallback((e) => {
    const v = e.target.value;
    // 지우면 "" 유지 (Number("") → 0 문제 방지)
    setRaw(v === "" ? "" : v);
  }, []);

  const onBlur = useCallback(() => {
    if (raw === "") return;                // 비어있으면 그대로
    const n = Number(raw);
    if (Number.isFinite(n)) setRaw(String(n));   // 정규화
    else setRaw("");                             // 잘못된 값은 비움
  }, [raw]);

  return {
    // 인풋에 바로 바인딩
    bind: {
      type: "number",
      value: raw,
      onChange,
      onBlur,
      onWheel: (e) => e.currentTarget.blur(), // 휠로 값 바뀌는 것 방지(선택)
      step: "any", // 정수만 원하면 "1"
      // min: 0,   // 음수 금지 원하면 사용
    },
    // 숫자 값이 필요할 때 사용 (빈값이면 null)
    number: raw === "" ? null : Number(raw),
    // 필요하면 직접 세터 접근
    setRaw,
  };
}
